diy.angular.registerDirective('diyfmsection', ['$timeout', 'diyfmsectionsdata', 'diyl10n', 'diyfmmessages', 'diysqueezebox',
function($timeout, diyfmsectionsdata, diyl10n, diyfmmessages, diysqueezebox) {

    var tpl = '\
        <div class="fm-subsection-name"\
            ng-hide="inEditMode" \
            title="{{subsection.getTitle()}}"\
            diyfminlineedit="nameEditConfig"\
            ng-bind-html="subsection.getTitle()"\
        ></div>\
        <button class="fm-menu-handle ui-button"\
            ng-click="menuClicked($event);" \
            ng-show="shouldShowMenuHandle(subsection);"\
        >\
            <span class="ui-icon ui-icon-menu"></span>\
        </button>';

    return {
        template: tpl,
        restrict: 'A',
        scope: {
            subsection: '=ngModel',
            openMenu: '&'
        },
        link: function(scope, elem, attr) {
            
            var $elem = jQuery(elem);

            scope.nameEditConfig = {
                // TODO make this text generic
                placeholder: diyl10n('filemanager.customerSection.newFolderText'),
                end: function(value) {
                    var isNew = scope.subsection.isNew();
                    scope.subsection.setTitle(
                        diyfmsectionsdata.generateUniqueSubsectionName(
                            value, 
                            scope.subsection, 
                            diyl10n('filemanager.customerSection.newFolderText')
                        )
                    );
                    if (isNew) {
                        scope.$emit('createdFolder');
                    }
                },
                cancel: function() {
                    if (scope.subsection.isNew()) {
                        diyfmsectionsdata.removeSubsection(scope.subsection);
                        scope.$apply();
                    }
                }
            };

            scope.menuClicked = function($event) {
                scope.openMenu({
                    menuConfig: {
                        menuTargetEl: $elem.find('.fm-menu-handle'),
                        getActions: function() {
                            return scope.subsection.getActions();
                        },
                        rename: function() {
                            scope.nameEditConfig.start(scope.subsection.getTitle());
                        },
                        'delete': function() {
                            diyfmmessages.showMessage({
                                title: diyl10n('filemanager.sections.menu.deleteconfirmation.message').format(scope.subsection.getTitle()),
                                ok: diyl10n('filemanager.sections.menu.delete'),
                                cancel: diyl10n('cancel')
                            }).then(function() {
                                diyfmsectionsdata.removeSubsection(scope.subsection);
                                scope.subsection.delete();
                                scope.$emit('deletedFolder');
                            });
                        }
                    }
                });
                $event.stopPropagation();// to stop click propagation
            };

            if (scope.subsection.isNew()) {
                // use timeout to let diyfminlineedit define scope.nameEditConfig.start
                $timeout(function(){
                    scope.nameEditConfig.start(scope.subsection.getTitle());

                    // update the squeeze box and scroll to item
                    diysqueezebox.refresh(jQuery('.fm-folders-list'));
                    diysqueezebox.scrollToItem(
                        jQuery('.fm-folders-list'),
                        jQuery('.fm-folders-list [data-diyfmsection] input[type="text"]').filter(':visible').closest('li')
                    );
                });
            }

            scope.shouldShowMenuHandle = function(subsection) {
                return subsection.getActions().length > 0;
            };


        }
    };
}]);




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmsection.js
 ** module id = 973
 ** module chunks = 0
 **/